import { patientQueryOptions } from "./patient-query";

export const patientSearchQuery = {
  list: (term: string, controller?: AbortController | null, n?: number) =>
    patientQueryOptions.search(term, controller, n),
};

export const blacklistQueryOptions = {
  list: () => patientQueryOptions.blacklist(),
};
